import React from 'react';
import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';
import { IconCircle, IconCircleColor } from './IconCircle';

interface StatCalloutProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: LucideIcon;
  iconColor?: IconCircleColor;
  label: string;
  value: string | number;
  sub?: string;
}

const StatCallout: React.FC<StatCalloutProps> = ({
  icon,
  iconColor = 'primary',
  label,
  value,
  sub,
  className,
  ...props
}) => (
  <div className={cn('flex items-center gap-3 p-4 bg-gray-50 rounded-md border border-gray-200', className)} {...props}>
    {icon && <IconCircle icon={icon} color={iconColor} />}
    <div className="min-w-0">
      <p className="text-xs text-gray-500 truncate">{label}</p>
      <p className="text-xl font-bold text-gray-900 leading-tight">{value}</p>
      {sub && <p className="text-xs text-gray-400 truncate">{sub}</p>}
    </div>
  </div>
);

export { StatCallout };
export type { StatCalloutProps };
